import { Typography } from '@mui/material'

const HelpText = () => {

  return (
    <div className='p-5'>
      <Typography variant='h5' className='pb-5'>Pass Notifications</Typography>
      <p>Here you see a history of notifications that you have sent to the pass.</p>
      <p>The table shows messages you have individually sent to to this pass as well
        as any you have sent to <i>all passes</i>.
      </p>
      <p>As with all our data table, you can download the data in a range of formats.</p>

      <Typography variant='h5' className='pt-10 pb-5'>Send a notification</Typography>
      <p>You can send a new notification by clicking the [SEND NOTIFICATION]
        button at the top of the table.
      </p>
    </div>
  )
}

export default HelpText